var React = require('react');

function SecureIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 22.5c-5.143-2.625-9-7.875-9-17.063L12 1.5l9 3.938c0 9.187-3.857 14.437-9 17.062z","fill":"#fff"}));
}

SecureIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = SecureIcon;

SecureIcon.default = SecureIcon;
